module.exports = __webpack_public_path__ + "img/more-options-on.605a69a4.svg";